import th from "./th";
import en from "./en";
import cn from "./cn";
import ms from "./ms";

const locales = { en, th, cn, ms };

export default locales;
